import { createAction, union } from '@ngrx/store';
import { Reservation } from 'src/app/models/reservation/reservation';
import { LoadingState } from './reservations.reducer';

export const updateLoadingState = createAction(
  'ReservationsActions updateLoadingState',
  (payload: LoadingState) => ({ payload }),
);

export const storeErrorMessage = createAction(
  'ReservationsActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const storeReservations = createAction(
  'ReservationsActions storeReservations',
  (payload: Reservation[]) => ({ payload }),
);

export const resetState = createAction('ReservationActions resetState');

const all = union({
  updateLoadingState,
  storeErrorMessage,
  storeReservations,
  resetState,
});

export type ReservationsActionsUnion = typeof all;
